"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIEW = exports.MEDIA = exports.DOWNLOAD = exports.ACTIONS = void 0;
exports.ACTIONS = {
    OUTBOUND_LINK_CLICK: 'Outbound link click',
    SEARCH: 'Search',
    SUBSCRIBE_FORM_SUBMIT: 'Subscribe form submit',
    SWITCH_LANGUAGE: 'Switch language',
};
exports.DOWNLOAD = {
    ATTACHMENT: 'Attachment download',
    GALLERY_IMAGE: 'Gallery image download',
    IMAGE: 'Image download',
    MEDIA_GALLERY: 'Media gallery download',
};
exports.MEDIA = {
    PLAY: 'Media play',
};
exports.VIEW = {
    GALLERY_IMAGE: 'Gallery image view',
    IMAGE: 'Image view',
};
//# sourceMappingURL=events.js.map